import { ActivatedRouteSnapshot, CanActivate, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { inject, Injectable } from '@angular/core';

/**
 * @deprecated Use accessGuard CanActivateFn instead
 */
@Injectable({
  providedIn: 'root'
})
export class AccessGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
      if (this.authService.isAuthenticated()) return true;
      const { provider, t } = route.queryParams;
      const redirect = state.url.replace(`&provider=${provider}`, '').replace(`&t=${t}`, '');
      await this.router.navigate(['/login'], { queryParams: { redirect, provider, t } });
      return false;
  }
  
}

export const accessGuard: CanActivateFn = (route, state) =>
  !inject(AuthService).isAuthenticated()
    ? inject(Router).navigate(['/login'])
    : true;
